export function initAttributeInfoTooltips() {
    let tooltip;

    document.querySelectorAll(".attribute-info[data-text]").forEach(e => e.addEventListener("mouseover", e => {
        const target = e.target.closest("[data-text]");
        if (!target) return;

        const text = target.dataset.text;
        if (!text) return;

        tooltip = document.createElement("div");
        tooltip.className = "tooltip--attribute-info";
        tooltip.innerHTML = text;
        document.body.appendChild(tooltip);

        const rect = target.getBoundingClientRect();
        tooltip.style.left = rect.left + window.scrollX + "px";
        tooltip.style.top = rect.bottom + window.scrollY + 6 + "px";
    }));

    document.body.addEventListener("mouseout", e => {
        if (tooltip && !e.relatedTarget?.closest("[data-text]")) {
            tooltip.remove();
            tooltip = null;
        }
    });
}